import React from 'react';
import {
  Box,
  Heading,
  Container,
  Button,
  FormControl,
  Text,
  Input,
  FormLabel,
  FormErrorMessage,
  useToast,
} from '@chakra-ui/react';
import { colors } from 'constants/constants';
import Link from 'next/link';
import { useContext } from 'react';
import SessionContext from 'session/SessionContext';
import { Formik, Field, Form, FormikHelpers } from 'formik';
import { useRouter } from 'next/router';

interface ResetPasswordProps {
  token: string;
}
export default function ResetPassword(props: ResetPasswordProps): JSX.Element {
  const session = useContext(SessionContext);
  const router = useRouter();
  const toast = useToast();
  interface FormValues {
    newPassword: string;
  }

  async function handleSubmitasync(
    values: FormValues,
    { setSubmitting }: FormikHelpers<FormValues>
  ) {
    await session.actions.resetPassword(props.token, values.newPassword);
    toast({
      title: 'Lösenord ändrat!',
      status: 'success',
      isClosable: true,
      position: 'top',
      description:
        'Ditt lösenord har ändrats, du kan börja använda det direkt!',
    });
    router.replace('/mypages');

    setSubmitting(false);
  }

  function validatePassword(pw: string) {
    let error;
    if (pw.length < 8) {
      error = 'Lösenordet måste vara längre än 8 tecken';
    }
    return error;
  }

  return (
    <>
      <Box flex="1" py="10" bg={colors.secondary[300]}>
        <Container maxW="7xl">
          <Heading as="h1" size="lg">
            Återställ lösenord
          </Heading>

          <Text>Här kan du återställa ditt lösenord</Text>

          <Box maxW="md" my="10">
            <Formik
              initialValues={{ newPassword: '' }}
              onSubmit={handleSubmitasync}>
              {(props) => {
                return (
                  <Form>
                    <Field name="newPassword" validate={validatePassword}>
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.newPassword && form.touched.newPassword
                          }>
                          <FormLabel mt={3} htmlFor="newPassword">
                            Nytt lösenord
                          </FormLabel>
                          <Input
                            isRequired={true}
                            type="password"
                            {...field}
                            id="newPassword"
                            placeholder=""
                            bg="white"
                          />
                          <FormErrorMessage>
                            {form.errors.newPassword}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Button
                      mt={4}
                      w="100%"
                      variant="ml"
                      isLoading={props.isSubmitting}
                      type="submit">
                      Spara
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Container>
      </Box>
    </>
  );
}
